module.exports = __webpack_public_path__ + "img/能源数据查询.de8ba668.png";